<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
      <LatestAnalysis v-if="!geoData" :data="data"></LatestAnalysis>
      <div class="headSectionIA">
        <span class="name"><translate>GAIA Google AI Alignment</translate></span>
        <div class="groupText">
          <div class="first">
            <translate>It measures whether the reputation generated by AI models is aligned, misaligned, or deviated from the average rating that Google shows for the brand.</translate>

          </div>
          <div class="second"><translate :translate-params="{ numberOfPrompts }">Analysis based on %{numberOfPrompts} prompts.</translate></div>
        </div>
      </div>
      <div class="box">
        <span class="title"><translate>GAIA Score</translate></span>
        <div class="gridGlobal">
          <div class="text-12 text-[#707070]">
            <p><translate>Alignment calculation: GAIA measures how close the IA Reputation Score and Google Reputation Score are to each other.</translate></p>
          </div>
          <div >
            <div class="boxChartGlobal">
              <ChartGaia :isBig="true" :value="data?.aggregated_google_ai_alignment?.google_ai_alignment"
                         :color="getColorByPercent(data?.aggregated_google_ai_alignment?.google_ai_alignment)"></ChartGaia>

            </div>
            <div class="flex flex-col justify-center items-center mt-3 m-auto text-center" :style="`color: ${getColorByPercent(data?.aggregated_google_ai_alignment?.google_ai_alignment)}`">
              <span class="font-medium text-[22px]">{{ getTextsByPercent(data?.aggregated_google_ai_alignment?.google_ai_alignment)?.title }}</span>
              <span class="font-medium text-[14px]">{{ getTextsByPercent(data?.aggregated_google_ai_alignment?.google_ai_alignment)?.subtitle }}</span>
            </div>
          </div>
          <div></div>
        </div>

        <div class="gridLLMGaia" :style="`grid-template-columns: repeat(${llms.length}, minmax(0, 1fr))`">
          <div v-for="(llm, index) in llms" :key="index" class="boxLLM">
            <div class="headLLM">
              <img :src="getLogoByLLM(llm)" />
            </div>
            <div class="px-3">
              <ChartGaia :value="data?.aggregated_google_ai_alignment?.by_provider[llm]"
                         :color="getColorByPercent(data?.aggregated_google_ai_alignment?.by_provider[llm])" class="w-full" />

            </div>
            <div class="flex flex-col justify-center items-center mt-3 text-center" :style="`color: ${getColorByPercent(data?.aggregated_google_ai_alignment?.by_provider[llm])}`">
              <span class="font-medium text-[14px] text-center">{{ getTextsByPercent(data?.aggregated_google_ai_alignment?.by_provider[llm])?.title }}</span>
              <span class="font-medium text-[12px] text-center">{{ getTextsByPercent(data?.aggregated_google_ai_alignment?.by_provider[llm])?.subtitle }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysis.vue"
import ChartGaia from "@/components/IAReputation/ChartGaia.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import SrvIAReputationService from "@/services/iareputation.js"
import SkeletonCard from '@/components/common/skeletonCard.vue'

export default {
  components: {LatestAnalysis, SkeletonCard, ChartGaia},
  mixins: [MixinIAReputation],
  props: ['geoData'],
  data() {
    return {
      data: null,
      loading: false,
      tabActive: 'indirect',
      showQuestion: false,
      dataQuestion: null,
      noAnalysis: false
    }
  },
  computed: {
    numberOfPrompts() {
      if (!this.data) return 0
      return this.data.reputation_index['openai'].prompts_answers.direct.filter(e => e.type === 'generic').length
    }
  },
  methods: {
    getColorByPercent(num) {
      if (num >= 85) { return '#109C00'}
      if (num >= 65 && num < 85) { return '#89C445' }
      if (num >= 40 && num < 65) { return '#FF9800' }
      if (num < 40) { return '#FE450A' }
    },
    getTextsByPercent(num) {
      if (num >= 85) { return {title: this.$gettext('Strongly aligned'), subtitle: ''}}
      if (num >= 65 && num < 85) { return {title: this.$gettext('Moderate alignment'), subtitle: this.$gettext('Normal')}}
      if (num >= 40 && num < 65) { return {title: this.$gettext('Significant misalignment'), subtitle: ''}}
      if (num < 40) { return {title: this.$gettext('Critical risk'), subtitle: this.$gettext('Google and AI do not agree')}}
    },
    async getData() {
      try {
        this.loading = true
        if (!this.geoData) {
          const {status, data} = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID})
          if (status === 200) {
            this.data = data
          }
        } else {
          this.data = this.geoData
        }
        this.noAnalysis = !this.data?.created_at || Object.values(this.data.aggregated_google_ai_alignment).length === 0
        this.loading = false
      } catch (e) {
        console.log(e)
      }
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped>
.gridGlobal{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 18px 28px;
}
.boxChartGlobal{
  width: 226px;
  margin: 0 auto;
}
.gridLLMGaia{
  margin-top: 30px;
  display: grid;
  gap: 5px;
  padding-right: 28px;
  padding-left: 28px;
  padding-bottom: 12px;
}
.gridLLMGaia .boxLLM{
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.gridLLMGaia .boxLLM .headLLM{
  background-color: #f4f5f9;
  border-radius: 8px;
  padding: 16px;
}
.gridLLMGaia .boxLLM .headLLM img{
  height: 23px;
  margin: 0 auto;
  display: block;
}
</style>
